export const Gender = {
  MALE: 'male',
  FEMALE: 'female',
  UNKNOWN: 'unknown',
};